var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderNav',{attrs:{"auth":_vm.$store.state.isAuth}}),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"notification-title"},[_vm._v(" Уведомления ")]),_c('NotificationList',{attrs:{"notifications":this.$store.state.notificationList}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }